
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

import userx from '@/store/modules/userx';
import schemax from '@/store/modules/schemax';

import {
	SoftwareType,
	SchemaDic,
	SchemaData,
	TableSchema,
	ExtractorSchema,
	ExtractorItem,
} from '@/store/models.def';
import uuid from 'uuid';
import ExtractorItemComponent from './ExtractorItem.vue';

@Component({
	components: {
		ExtractorItemComponent,
	},
})
export default class ExtractorSchemaComponent extends Vue {
	@Prop({ default: { '': [uuid.v4(), 'EQUAL', ''] } })
	public value!: ExtractorSchema;

	public extractor: Array<{
		id: string;
		field: string;
		item: ExtractorItem;
	}> = [];

	@Watch('value')
	public onValueChanged(val: ExtractorSchema, oldVal: ExtractorSchema) {
		if (val !== null) {
			this.extractor = Object.keys(val).map((field) => {
				return { id: val[field][0], field, item: val[field] };
			});
			const result = this._validfy();
			if (result === null) {
				this.$emit('input', null);
			}
		}
	}
	public addField() {
		const id = uuid.v4();
		this.extractor.push({ id, field: '', item: [id, 'EQUAL', ''] });
	}
	public removeField(id: string) {
		this.extractor = this.extractor.filter((item) => item.id !== id);
		this._onInput();
	}
	public mounted() {
		if (this.value) {
			this.extractor = Object.keys(this.value).map((field) => {
				return { field, item: this.value[field], id: this.value[field][0] };
			});
			const result = this._validfy();
			if (result == null) {
				this.$emit('input', null);
			}
		}
	}
	protected _onInput() {
		this.$emit('input', this._validfy());
	}
	protected _validfy() {
		const result: ExtractorSchema = {};
		for (const data of this.extractor) {
			if (!data.field || !data.item) {
				return null;
			}
			result[data.field] = data.item;
		}
		return result;
	}
}
